import React from 'react';
import { ICampItem } from '../../tempDB';
import ImgWithFallback from '../ui/ImgWithFallback';

interface ICampItemProp {
    item: ICampItem
    handleClick: () => void
}

const CampContentItem = ({ item, handleClick }: ICampItemProp) => {
    const { images, title } = item

    return (
        <div className="camp__content-column" onClick={handleClick}>
            <h2 className="column__title">{title}</h2>
            <ImgWithFallback src={images.webp} fallbackSrc={images.img} />
        </div>
    );
};

export default CampContentItem;